define(function (require)
{
    //var isTesting = $mbww.qsParamValue('selenium') == '1';

    //history module : register messages from javascript that can be queried from selenium tests
    var _history = (function () {

        var _aoLogStack = [];

        function log(topic, msg, data) {
            //if (!isTesting) { return; }

            var x = { t: topic, msg: msg };
            if (data) { x.data = data; }

            _aoLogStack.push(x);
        }

        function clearLogs() {
            _aoLogStack = [];
        }

        //returns '': not found, 'y' : found, [error text] : error found 
        function searchLogs(fnFilter, bClear, bIgnoreErrors) {

            //console.log('searchLogs ' + _aoLogStack.map(function (x) { return (x.t + '.' + (x.msg || '')); }).join(','), fnFilter);

            var result = '';
            var x;
            for (var i = 0; i < _aoLogStack.length; i++) {
                x = _aoLogStack[i];

                if (fnFilter(x)) {
                    result = 'y';
                    break;
                }
                else if (x.t == 'error' && !bIgnoreErrors) {
                    result = x.msg;
                    break;
                }

            }

            if (bClear) {
                clearLogs();
            }

            return result;
        }

        function getLogs()
        {
            return _aoLogStack.slice();
        }

        return { log: log, clearLogs: clearLogs, searchLogs: searchLogs, getLogs: getLogs };

    }).call();

   



    var exports = {

        //isTesting: isTesting,
        log: _history.log,
        clearLogs: _history.clearLogs,
        searchLogs: _history.searchLogs,
        getLogs: _history.getLogs,

        getFirstError: function (bClear) {
            //match no log and wait for the find to break on error;
            return _history.searchLogs(function (x) { return false; }, bClear);
        }

    };


    //expose an object in the global scope to manipulate it easily from selenium
    if (!window['QSelenium'])
    {
        window['QSelenium'] = exports;
    }

    return exports;



});